import { render, staticRenderFns } from "./TestDialog.vue?vue&type=template&id=0fd071f5&scoped=true&"
import script from "./TestDialog.vue?vue&type=script&lang=js&"
export * from "./TestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd071f5",
  null
  
)

export default component.exports